import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { TextField, Typography } from '@mui/material';

import { INVALID_FIELD } from '../../../../../shared';

import {
  StyledBigInputContainer,
  StyledFormLegend,
  StyledInputGroup,
  StyledSmallInputContainer,
  StyledVerticalContent,
} from './PersonalDetails.styled';

export default function AddressForm(props) {
  const {
    address,
    houseNumber,
    postcode,
    city,
    onAddressChange,
    onHouseNumberChange,
    onPostcodeChange,
    onCityChange,
    postCodeStatus,
  } = props;
  const intl = useIntl();

  const handleStreetChange = (event) => {
    const streetValue = event.target.value;
    const sanitizedStreetValue = streetValue ? streetValue.replace(/  +/g, ' ') : '';
    const newEvent = { target: { value: sanitizedStreetValue } };
    onAddressChange(newEvent);
  };

  const handleHouseNumberChange = (event) => {
    const houseNumberValue = event.target.value;
    const sanitizedHouseNumberValue = houseNumberValue ? houseNumberValue.replace(/  +/g, ' ') : '';
    const newEvent = { target: { value: sanitizedHouseNumberValue } };
    onHouseNumberChange(newEvent);
  };

  const handlePostCodeChange = (event) => {
    onPostcodeChange(event);
  };

  const handleCityChange = (event) => {
    const cityValue = event.target.value;
    const sanitizedCityValue = cityValue
      ? cityValue.replace(/[0-9]/g, '').replace(/  +/g, ' ')
      : '';
    const newEvent = { target: { value: sanitizedCityValue } };
    onCityChange(newEvent);
  };

  return (
    <StyledVerticalContent>
      <fieldset>
        <StyledFormLegend>
          <Typography variant="h3">
            <FormattedMessage id="new_claim.form.label.street_number" />
          </Typography>
        </StyledFormLegend>

        <StyledInputGroup>
          <StyledBigInputContainer>
            <TextField
              fullWidth
              id="address"
              name="address"
              placeholder={intl.formatMessage({ id: 'placeholder.contact.street' })}
              value={address || ''}
              onChange={handleStreetChange}
            />
          </StyledBigInputContainer>

          <StyledSmallInputContainer>
            <TextField
              fullWidth
              id="houseNumber"
              name="houseNumber"
              placeholder={intl.formatMessage({ id: 'placeholder.contact.house.number' })}
              value={houseNumber || ''}
              onChange={handleHouseNumberChange}
            />
          </StyledSmallInputContainer>
        </StyledInputGroup>
      </fieldset>

      <fieldset>
        <StyledFormLegend>
          <Typography variant="h3">
            <FormattedMessage id="personal.details.form.postcode.city.label" />
          </Typography>
        </StyledFormLegend>

        <StyledInputGroup>
          <StyledSmallInputContainer>
            <TextField
              fullWidth
              id="postcode"
              name="postcode"
              placeholder="10234"
              value={postcode || ''}
              onChange={handlePostCodeChange}
              slotProps={{
                input: {
                  autoComplete: 'postal-code',
                },
              }}
            />
          </StyledSmallInputContainer>

          <StyledBigInputContainer>
            <TextField
              fullWidth
              id="city"
              name="city"
              placeholder={intl.formatMessage({ id: 'placeholder.account.city' })}
              value={city || ''}
              onChange={handleCityChange}
              slotProps={{
                input: {
                  autoComplete: 'locality',
                },
              }}
            />
          </StyledBigInputContainer>
        </StyledInputGroup>
      </fieldset>

      {postCodeStatus === INVALID_FIELD && (
        <Typography variant="p" color="error" data-testid="error-postcode">
          <FormattedMessage id="new_claim.invalid.postcode" />
        </Typography>
      )}
    </StyledVerticalContent>
  );
}
